import properties from '../properties';

const concatUrl = (base: string, path: string) =>
  `${base.replace(/\/?$/, '')}/${path.replace(/^\/+/, '')}`;

export const createAemUrl = (path: string) =>
  concatUrl(properties.AemBaseUrl, path);

export const createFptUrl = (path: string) =>
  concatUrl(properties.FptBackendUrl, path);

export const createFpfcUrl = (path: string) =>
  concatUrl(properties.FpfcBackendUrl, path);

export const createProxyUrl = (url: string) => {
  const paramsString = `redirect=${url}`;
  return concatUrl(
    properties.FpgBffUrl,
    `${properties.Paths.fpgProxy}?${paramsString}`
  );
};

export const createUnauthProxyUrl = (url: string) => {
  const paramsString = `redirect=${url}`;
  return concatUrl(
    properties.FpgBffUrl,
    `${properties.Paths.fpgUnauthProxy}?${paramsString}`
  );
};
